import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getEmailLogsKey } from '../../utils/keys';
export const useEmailLogs = (options) => {
    const { variables, useInfiniteQueryOptions } = options || {};
    const { client } = useTribeClient();
    const emailLogsKey = getEmailLogsKey(variables);
    return useInfiniteQuery(emailLogsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.emailLogs({ after, ...variables }), useInfiniteQueryOptions);
};
//# sourceMappingURL=useEmailLogs.js.map